<template>
  <div>
    <h5>
      {{ $t("form.title") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="9" class="py-0">
        <v-text-field
          v-model="publication.title"
          :label="$t('form.title')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" class="py-0">
        <v-checkbox
          class="big"
          readonly
          v-model="publication.is_external"
          :label="$t('form.publication.external')"
        />
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.abstract") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-textarea
          v-model="publication.abstract"
          :label="$t('form.abstract')"
          required
          outlined
          readonly
        ></v-textarea>
      </v-col>
    </v-row>
    <h5>{{ $t("form.keywords") }}</h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.keywords"
          :label="$t('form.keywords')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" class="py-0">
        <h5>{{ $t("form.authors_text") }}</h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.authors_text"
              :label="$t('form.authors_text')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" class="py-0">
        <h5>{{ $t("form.num_authors") }}</h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.num_authors"
              :label="$t('form.num_authors')"
              required
              readonly
              outlined
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <h5>{{ $t("form.authors") }}</h5>
    <SelectPeopleComboBox
      :disabled-form="true"
      :items-selected="publication.authorsrel"
    />
    <h5>
      {{ $t("form.acknowledgements") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-textarea
          v-model="publication.acknowledgements"
          readonly
          :label="$t('form.acknowledgements')"
          outlined
        ></v-textarea>
      </v-col>
    </v-row>
    <h5>
      {{ $t('form.doi') }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.doi"
          :label="$t('form.doi')"
          required
          :readonly="disabledForm"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <h5>
      {{ $t('form.isbn') }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.isbn"
          :label="$t('form.isbn')"
          required
          readonly
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.publication.research_areas") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-select
          :items="researchAreas"
          v-model="publication.research_areas"
          :label="$t('form.publication.research_areas')"
          required
          :item-text="'name.' + $i18n.locale"
          item-value="id"
          outlined
          readonly
          multiple
        ></v-select>
      </v-col>
    </v-row>
    <h5>{{ $t("collaborations") }}</h5>
    <v-row>
      <v-col col="12" md="6" lg="4" class="py-0">
        <v-checkbox
          class="big"
          v-model="publication.regional"
          :label="$t('form.publication.regional')"
          readonly
        />
      </v-col>
      <v-col col="12" md="6" lg="4" class="py-0">
        <v-checkbox
          class="big"
          v-model="publication.national"
          :label="$t('form.publication.national')"
          readonly
        />
      </v-col>
      <v-col col="12" md="6" lg="4" class="py-0">
        <v-checkbox
          class="big"
          v-model="publication.international"
          :label="$t('form.publication.international')"
          readonly
        />
      </v-col>
    </v-row>

    <h5>Links</h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.links.publisher"
          :label="$t('label.links.publisher')"
          outlined
          readonly
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.links.institutional_repository"
          :label="$t('label.links.institutional_repository')"
          outlined
          readonly
        />
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.links.personal_repository"
          :label="$t('label.links.personal_repository')"
          outlined
          readonly
        />
      </v-col>
      <v-col v-if="teseo_link" cols="12" class="py-0">
        <v-text-field
          v-model="publication.links.teseo"
          :label="$t('label.links.teseo')"
          outlined
          readonly
        />
      </v-col>
    </v-row>
    <h5>{{ $t("form.files") }}</h5>
    <UploadFiles
      v-if="modOp_id !== null"
      object_type="publication"
      :id="this.modOp_id"
      :final="false"
      :read-only="true"
    />
  </div>
</template>

<script>
import UploadFiles from "../../reusables/UploadFiles";
import SelectPeopleComboBox from "../../reusables/SelectPeopleComboBox";
import publication_model from "../../../mixins/model_utils/publication_model";
export default {
  mixins: [publication_model],
  components: { UploadFiles, SelectPeopleComboBox },
  name: "ReviewPublication",
  props: {
    publication: Object,
    modOp_id: Number,
    teseo_link: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.getResearchAreas();
  }
};
</script>

<style scoped></style>
